import React from 'react'
import { Header, Footer } from '../layouts'
import { useRecoilValue } from 'recoil'
import { langAtom } from '../../atoms'
import { useLocation } from '@reach/router'
import { langFromPath } from '../../utils/language'

const Layout = ({ children }: any) => {

  const location = useLocation()
  const recoilLang = useRecoilValue(langAtom)
  const lang = langFromPath(location.pathname) || recoilLang
  return (
    <div
    className={`${lang !== 'ZH' && lang !== 'TW' && 'yumin'}`}
    >
      <Header />
      {children}
      <Footer />
    </div>
  )
}

export default Layout
